<template>
  <vs-popup title="산업안전관리비(계상금액) 기준표" :active.sync="show" id="popup-산업안전관리비">
    <h4 class="title">계상방법</h4>
    <table>
      <thead>
        <tr>
          <th colspan="2">구분</th>
          <th>대상액(A)</th>
          <th>안전관리비 계산식</th>
          <th>비고</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2">공사비내역 구분</td>
          <td style="width: 70px">①</td>
          <td>직접재료비 + 간접재료비 + 직접노무비</td>
          <td>대상액(A) × 계상요율</td>
          <td rowspan="2">① 계산금액 / ② 계산금액 中 작은 금액으로 계산</td>
        </tr>
        <tr>
          <td>②</td>
          <td>① - (발주자제공재료비 + 완제품재료비)</td>
          <td>대상액(A) × 계상요율 × 1.2</td>
        </tr>
        <tr>
          <td colspan="2">공사비내역 구분 불분명</td>
          <td>총 공사금액(부가가치세 포함) × 70%</td>
          <td>대상액(A) × 계상요율</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="5">단, 5억 이상 50억 미만 계산식: 대상액 × 비율(X) + 기초액(C)</td>
        </tr>
      </tbody>
    </table>

    <h4 class="title">계상요율</h4>
    <table class="table-2">
      <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th rowspan="2">5억 미만 요율(%)</th>
          <th colspan="2">5억 이상 50억 미만</th>
          <th rowspan="2">50억 이상 요율(%)</th>
        </tr>
        <tr>
          <th>요율(%)</th>
          <th>기초액</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>건축공사</td>
          <td>3.11%</td>
          <td>2.28%</td>
          <td>4,325,000원</td>
          <td>2.37%</td>
        </tr>
        <tr class="highlight">
          <td>토목공사</td>
          <td>3.15%</td>
          <td>2.53%</td>
          <td>3,300,000원</td>
          <td>2.60%</td>
        </tr>
        <tr>
          <td>중건설공사</td>
          <td>3.64%</td>
          <td>3.05%</td>
          <td>2,975,000원</td>
          <td>3.11%</td>
        </tr>
        <tr>
          <td>특수건설공사</td>
          <td>2.07%</td>
          <td>1.59%</td>
          <td>2,450,000원</td>
          <td>1.64%</td>
        </tr>
      </tbody>
    </table>
  </vs-popup>
</template>

<script>
export default {
  props: { value: Boolean },
  data() {
    return {
      show: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.show = value;
      },
    },
    show: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#popup-산업안전관리비::v-deep {
  .vs-popup {
    max-width: 1095px;
    width: 96%;
  }
}

.title {
  border-left: 8px solid #002452;
  padding-left: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}
th,
td {
  border: 1px solid #a0a5ab;
  padding: 8px 2px;
  text-align: center;
}
th {
  color: #002452;
  font-size: 14px;
  background-color: #d8e0e8;
  padding: 12px 2px;
}

.table-2 td {
  color: #002452;
}
.highlight {
  text-decoration: underline;
  background-color: #fbf1e2;
}
</style>
